import { useTranslation } from 'react-i18next';
import { CiLogout } from 'react-icons/ci';
import { FaHouseUser, FaRegUserCircle, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Menu, Text } from '@mantine/core';
import { PocketBaseService } from '@/services/pocketbase.service';
import { useAuthedUserStore } from '@/store/store';

const pb = PocketBaseService.getInstance().getPocketBase();

function getInitials(name?: string | null): string {
  if (!name?.trim()) {
    return '?';
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase();
}

export function UserMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { clearAuthedUser, user } = useAuthedUserStore();
  const isLogged = pb.authStore.isValid;
  const recordName = (pb.authStore.record?.name as string | undefined) || user?.name || '';

  const handdleLogout = () => {
    pb.authStore.clear();
    window.location.href = '/login';
    clearAuthedUser();
  };

  const renderGuestMenu = () => {
    return (
      <>
        <Menu.Item onClick={() => navigate('/login')} leftSection={<FaUser size={16} />}>
          <Text size="md">{t('user-menu-sign-in-up')}</Text>
        </Menu.Item>
      </>
    );
  };

  const renderLoggedMenu = () => {
    return (
      <>
        <Menu.Item
          onClick={() => navigate('/my-profile')}
          leftSection={<FaRegUserCircle size={16} />}
        >
          <Text size="md">{t('user-menu-my-profile')}</Text>
        </Menu.Item>
        <Menu.Item
          onClick={() => navigate('/my-residence')}
          leftSection={<FaHouseUser size={16} />}
        >
          <Text size="md">{t('user-menu-my-residence')}</Text>
        </Menu.Item>
        <Menu.Item onClick={handdleLogout} leftSection={<CiLogout size={16} />}>
          <Text size="md">{t('user-menu-logout')}</Text>
        </Menu.Item>
      </>
    );
  };

  return (
    <Menu shadow="lg" width={300}>
      <Menu.Target>
        <button
          type="button"
          className={`user-avatar-btn ${isLogged ? 'is-logged' : ''}`}
          aria-label={t('user-menu-aria-label')}
        >
          {isLogged ? (
            <span className="user-avatar-btn__initials">{getInitials(recordName)}</span>
          ) : (
            <FaUser size={16} />
          )}
        </button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>
          <Text size="lg">{t('user-menu-label-user-options')}</Text>
        </Menu.Label>
        <Menu.Divider />
        {isLogged ? renderLoggedMenu() : renderGuestMenu()}
      </Menu.Dropdown>
    </Menu>
  );
}
